import { createReducer } from '@reduxjs/toolkit';
import { slcGeoCoords } from 'store/geolocation/constants';
import { GeolocationPermissionsStatus } from './types';
import * as fromActions from './actions';

export interface GeolocationState extends Partial<Position> {
  status: GeolocationPermissionsStatus;
  errorShown?: boolean;
  coords?: any;
  timestamp?: number;
}

export const initialState: GeolocationState = {
  status: GeolocationPermissionsStatus.UNKNOWN,
  coords: null,
  errorShown: false,
  timestamp: 0
};

const geolocationReducer = createReducer(initialState, {
  [fromActions.SET_GEO_LOCATION]: (state, action) => {
    const { coords, timestamp } = action.payload;

    return {
      coords,
      timestamp,
      status: GeolocationPermissionsStatus.ACCEPTED,
      errorShown: false
    };
  },
  [fromActions.SET_GEO_LOCATION_ERROR_SHOWN]: (state, action) => {
    state.errorShown = action.errorShown;
  },
  [fromActions.SET_GEO_LOCATION_FAIL]: state => {
    return { ...state, status: GeolocationPermissionsStatus.DENIED, coords: slcGeoCoords };
  }
});

export default geolocationReducer;
